import { BuildingDTO } from "./building";
import { Resource } from "./resource";

export type WindowDto = {
  windowId?: number;
  status: BuildingParticleStatus;
  particleId?: number;
  description?: string;
  location: WindowLocation;
  type?: WindowType;
  material?: WindowMaterial;
  profileColor?: string;
  sillType?: SillType;
  stoneType?: StoneType;
  glassPlacement?: GlassPlacement;
  openingDirection?: OpeningDirection;
  paneDivision?: PaneDivision;
  ugValue?: number;
  glassThickness?: number;
  sharePointPicturesFolderId?: string;
  sharePointPicturesFolderUrl?: string;
  installer: Resource;
  building: BuildingDTO;
  // Opleveringsdatum
  deliveryDate: Date;
  nextInspectionDate: Date;
}

export enum BuildingParticleStatus {
  TO_BE_CHECKED = "Na te kijken",
  GOOD = "Goede staat",
  BAD = "Slechte staat",
}

export enum WindowLocation {
  TO_BE_CHECKED = "Na te kijken",
  FRONT = "Voorgevel",
  SIDE_LEFT = "Zijgevel links",
  SIDE_RIGHT = "Zijgevel rechts",
  BACK = "Achtergevel",
}

export enum WindowType {
  TO_BE_CHECKED = "Na te kijken",
  FIXED = "Vaste ramen",
  TURN_AND_TILT = "Draaikiepramen",
  TILT = "Kiepramen",
  TURN = "Draairamen",
  OUTSET = "Uitzetramen",
  KOZIJN = "Kozijnen",
}

export enum WindowMaterial {
  TO_BE_CHECKED = "Na te kijken",
  WOOD = "Hout",
  PVC = "PVC",
  ALUMINIUM = "Aluminium",
}

export enum SillType {
  TO_BE_CHECKED = "Na te kijken",
  NATURAL_STONE = "Natuursteen",
  WOOD = "Hout",
}

export enum StoneType {
  TO_BE_CHECKED = "Na te kijken",
  PAINTED_STONE = "Geschilderde arduin",
  BLUESTONE = "Blauwe steen",
}

export enum GlassPlacement {
  TO_BE_CHECKED = "Na te kijken",
  INSIDE = "Binnenzijde",
  OUTSIDE = "Buitenzijde",
}

export enum OpeningDirection {
  TO_BE_CHECKED = "Na te kijken",
  INWARD = "Binnenwaarts",
  OUTWARD = "Buitenwaarts",
}

export enum PaneDivision {
  TO_BE_CHECKED = "Na te kijken",
  YES = "Ja",
  NO = "Nee",
}